/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageRecruit.vue?vue&type=template&id=4f2212db"
import script from "./pageRecruit.vue?vue&type=script&lang=js"
export * from "./pageRecruit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports